import { Injectable } from '@angular/core';
import { DabGQL, DabHistoryGQL } from '@epicuro-next/data/product';
import { DabQuery } from 'graphql-api/gql-api-interfaces';
import { map } from 'rxjs/operators';

/**
 * Service to fetch product dab data
 */
@Injectable()
export class DabService {
  /**
   * Dependencies
   * @param dabGql GraphQL
   */
  constructor(private dabGql: DabGQL, private dabHistoryGQL: DabHistoryGQL) {}

  /**
   * Fetches the DAB from GQL
   */
  public getDab(query: DabQuery) {
    return this.dabGql.fetch({ query }).pipe(map(({ data }) => data));
  }

  /**
   * Fetches the DAB history from GQL
   */
  public getDabHistory(query: DabQuery) {
    return this.dabHistoryGQL.fetch({ query }).pipe(map(({ data }) => data));
  }
}
